import { render, staticRenderFns } from "./LaplacianCourse.vue?vue&type=template&id=70bcc544&scoped=true"
import script from "./LaplacianCourse.vue?vue&type=script&lang=js"
export * from "./LaplacianCourse.vue?vue&type=script&lang=js"
import style0 from "./LaplacianCourse.vue?vue&type=style&index=0&id=70bcc544&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bcc544",
  null
  
)

export default component.exports